<div class="btn btn-primary" (click)="add()" style="cursor: pointer;">Add user</div>
<table class="table">
    <thead>
      <tr>
        <th scope="col">Username</th>
        <th scope="col">Name</th>
        <th scope="col">Department</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
<tr *ngFor="let item of users[0]">
    <td>{{item.username}}</td>
    <td>{{item.name}}</td>
    <td>{{item.department_name}}</td>
    <td class="text-end">
        <div class="btn btn-primary" (click)="edit(item.id)" style="cursor: pointer;">Edit</div>
    </td>
</tr>
</tbody>
</table>